(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("alg"), require("kpuzzle"));
	else if(typeof define === 'function' && define.amd)
		define(["alg", "kpuzzle"], factory);
	else if(typeof exports === 'object')
		exports["min2phase"] = factory(require("alg"), require("kpuzzle"));
	else
		root["min2phase"] = factory(root["alg"], root["kpuzzle"]);
})(typeof self !== "undefined" ? self : this, function(__WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 